<div class="container-fluid vh-100 d-flex justify-content-center align-items-center p-0">
  <div class="main-panels d-flex w-100">
    <!-- Left Panel -->
    <div class="left-panel">
      <div class="text-center px-4">
        <h2 class="mb-2">CRM Platform To Grow Your Business</h2>
        <p class="mb-4">
          Streamline operations, enhance customer experiences, and drive growth with our all-in-one travel industry
          solutions.
        </p>
      </div>
      <div>
        <img src="assets/Images/landing-section-img.png" alt="CRM Preview Screens" class="img-fluid rounded shadow" />
      </div>
    </div>

    <!-- Right Panel -->
    <div class="right-panel position-relative" *ngIf="!isSubmittedAndVerified">
      <h2 class="fw-bold">Let's Connect Beyond The Event</h2>
      <form class="signup-form" [formGroup]="signupForm" (ngSubmit)="onSubmit()">
        <div class="row mb-3">
          <div class="col-6">
            <div class="input-container">
              <div
                [ngClass]="{ 'invalid-input': signupForm.get('firstName')?.touched && signupForm.get('firstName')?.invalid }">
                <span class="warning-message ms-1"
                  *ngIf="signupForm.get('firstName')?.touched && signupForm.get('firstName')?.invalid">First name is
                  required</span>
                <input class="input" type="text" placeholder="First Name*" formControlName="firstName" />
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6">
            <div class="input-container">
              <div
                [ngClass]="{ 'invalid-input': signupForm.get('lastName')?.touched && signupForm.get('lastName')?.invalid }">
                <span class="warning-message ms-1"
                  *ngIf="signupForm.get('lastName')?.touched && signupForm.get('lastName')?.invalid">Last name is
                  required</span>
                <input class="input" type="text" placeholder="Last Name *" formControlName="lastName" />
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <div class="input-container">
              <div
                [ngClass]="{ 'invalid-input': signupForm.get('email')?.touched && signupForm.get('email')?.invalid }">
                <span class="warning-message ms-1"
                  *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.invalid && !signupForm.get('email')?.hasError('emailTaken')">Email
                  ID is required and must be valid</span>
                <div *ngIf="signupForm.get('email')?.hasError('emailTaken') && signupForm.get('email')?.touched">
                  <span class="warning-message">User already exists with this email</span>
                </div>
                <input class="input" type="email" placeholder="Email ID*" formControlName="email" />
              </div>

            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <div class="input-container">
              <!-- Use formControlName phoneNumber as per your TS -->
              <div
                [ngClass]="{ 'invalid-input': signupForm.get('phoneNumber')?.touched && signupForm.get('phoneNumber')?.invalid }">
                <span class="warning-message ms-1"
                  *ngIf="signupForm.get('phoneNumber')?.touched && signupForm.get('phoneNumber')?.invalid">Phone number
                  is required</span>
                <app-phone-country-input formControlName="phoneNumber"></app-phone-country-input>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <div class="input-container">
              <div
                [ngClass]="{ 'invalid-input': signupForm.get('organizationName')?.touched && signupForm.get('organizationName')?.invalid }">
                <span class="warning-message ms-1"
                  *ngIf="signupForm.get('organizationName')?.touched && signupForm.get('organizationName')?.invalid">Organization
                  name is required</span>
                <input class="input" type="text" placeholder="Organization Name*" formControlName="organizationName" />
              </div>
            </div>
          </div>
        </div>

        <!-- Organization Type -->
        <div class="row mb-3">
          <div class="col-6">
            <div class="input-container">
              <div [ngClass]="{
        'invalid-input':
          signupForm.get('organizationType')?.touched &&
          signupForm.get('organizationType')?.invalid
      }">
                <span class="warning-message ms-1" *ngIf="
          signupForm.get('organizationType')?.touched &&
          signupForm.get('organizationType')?.invalid
        ">
                  Organization Type is required
                </span>

                <!-- Radio buttons instead of select -->
                <div class="radio-group">
                  <label class="radio-item" *ngFor="let type of organizationType">
                    <input type="radio" formControlName="organizationType" [value]="type.key" />
                    <span>{{ type.name }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <div class="col-12">
              <app-address-fields formControlName="address" [isRequired]="true"></app-address-fields>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <div class="input-container">
              <div
                [ngClass]="{ 'invalid-input': signupForm.get('companySize')?.touched && signupForm.get('companySize')?.invalid }">
                <select class="input" formControlName="companySize">
                  <option value="" disabled>Company Size *</option>
                  <option value="1-10">1-10</option>
                  <option value="11-50">11-50</option>
                  <option value="51-200">51-200</option>
                  <option value="201-500">201-500</option>
                  <option value="500+">500+</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="signupForm.get('agree')?.touched && signupForm.get('agree')?.invalid"
          class="text-danger input-container">
          <span class="warning-message">You must agree to the Privacy Policy.</span>
        </div>
        <div class="agreement-container">

          <div class="checkbox">
            <input type="checkbox" id="agree" formControlName="agree" required />
            <label for="agree">
              I agree to the
              <span class="clickable-text" (click)="privacyAndPolicy()">Privacy Policy</span>
            </label>
          </div>

          <p class="login-text">
            Already a user?
            <span class="clickable-text" routerLink="/login">Login Here</span>
          </p>

        </div>
        <div class="row">
          <div class="col-6">
            <button type="submit" class="submit-btn w-100">Submit</button>
          </div>
        </div>
      </form>
    </div>

    <!-- congratulations message -->
    <div class="welcome-container" *ngIf="isSubmittedAndVerified">
      <div class="middle-panel">
        <!-- Show on successful verification -->
        <div class="message-box">
          <h1>🎉 You're all set!</h1>
          <p class="mb-1">
            Your organization has been created. We've sent you an email to reset your password.
          </p>
          <p>
            Just follow the link in that email to set a new password. Once you're done, you will be redirected to login
            page and get
            started!
          </p>
        </div>
      </div>
    </div>

    <!-- Assistance Section -->
    <div class="assistance d-flex flex-column justify-content-center px-4">
      <h5 class="fw-bold text-primary mb-1">Need Assistance</h5>
      <p class="mb-3 text-muted">Contact us for more details</p>

      <p class="mb-3">
        <ion-icon name="call-outline" class="me-2"></ion-icon>
        +91 9281412020 / +91 9281412030
      </p>

      <p>
        <ion-icon name="mail-outline" class="me-2"></ion-icon>
        {{"contact@tripmeld.com"}}
      </p>
    </div>
  </div>

  <app-spinner *ngIf="showSpinner"></app-spinner>
</div>